import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Plus, Trash } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function AdminProducts() {
  const [products, setProducts] = useState([]);
  const [open, setOpen] = useState(false);
  const empty = { name: "", sku: "", category: "", description: "", price: 0, image_url: "", stock: 100, active: true };
  const [form, setForm] = useState(empty);

  const load = async () => { const { data } = await api.get("/products"); setProducts(data || []); };
  useEffect(() => { load(); }, []);

  const submit = async () => {
    try { await api.post("/products", form); toast.success("Product created"); setOpen(false); setForm(empty); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const remove = async (id) => { if (confirm("Delete?")) { await api.delete(`/products/${id}`); load(); } };

  return (
    <div className="space-y-6" data-testid="admin-products-page">
      <div className="flex items-end justify-between gap-3 flex-wrap">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Admin</div>
          <h1 className="font-display text-4xl font-black tracking-tight mt-1">Products</h1>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button className="rounded-sm bg-[var(--uc-primary)] hover:bg-[var(--uc-primary-hover)] text-white" data-testid="new-product-btn"><Plus size={16} className="mr-1" /> New product</Button>
          </DialogTrigger>
          <DialogContent className="rounded-sm max-w-lg">
            <DialogHeader><DialogTitle>New product</DialogTitle></DialogHeader>
            <div className="grid sm:grid-cols-2 gap-3">
              <div className="sm:col-span-2"><Label>Name</Label><Input value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} className="rounded-sm mt-1" data-testid="prod-name" /></div>
              <div><Label>SKU</Label><Input value={form.sku} onChange={(e) => setForm({...form, sku: e.target.value})} className="rounded-sm mt-1" /></div>
              <div><Label>Category</Label><Input value={form.category} onChange={(e) => setForm({...form, category: e.target.value})} className="rounded-sm mt-1" /></div>
              <div><Label>Price (CAD)</Label><Input type="number" step="0.01" value={form.price} onChange={(e) => setForm({...form, price: parseFloat(e.target.value || 0)})} className="rounded-sm mt-1" /></div>
              <div><Label>Stock</Label><Input type="number" value={form.stock} onChange={(e) => setForm({...form, stock: parseInt(e.target.value || 0)})} className="rounded-sm mt-1" /></div>
              <div className="sm:col-span-2"><Label>Image URL</Label><Input value={form.image_url} onChange={(e) => setForm({...form, image_url: e.target.value})} className="rounded-sm mt-1" /></div>
              <div className="sm:col-span-2"><Label>Description</Label><Textarea value={form.description} onChange={(e) => setForm({...form, description: e.target.value})} className="rounded-sm mt-1" /></div>
            </div>
            <DialogFooter><Button onClick={submit} className="rounded-sm bg-[var(--uc-primary)] hover:bg-[var(--uc-primary-hover)] text-white" data-testid="prod-save">Create</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      <Card className="rounded-sm border-border overflow-hidden">
        <table className="w-full text-sm dense">
          <thead className="bg-muted/40 text-left text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
            <tr><th>Name</th><th>SKU</th><th>Category</th><th className="text-right">Price</th><th>Stock</th><th></th></tr>
          </thead>
          <tbody>
            {products.map((p) => (
              <tr key={p.product_id} className="border-t border-border" data-testid={`prod-row-${p.product_id}`}>
                <td className="font-medium">{p.name}</td>
                <td className="font-mono text-xs">{p.sku}</td>
                <td className="text-muted-foreground">{p.category}</td>
                <td className="text-right font-display font-bold">${p.price.toFixed(2)}</td>
                <td>{p.stock}</td>
                <td className="text-right"><button className="p-2 text-muted-foreground hover:text-destructive" onClick={() => remove(p.product_id)}><Trash size={14} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
